import React, { ReactElement } from 'react';
import './style.scss';
import { NavLink } from 'react-router-dom';

type RequestProps = {
  label: string;
  right?: ReactElement;
};

export const Caption = (props: RequestProps) => {
  const { label, right } = props;
  return (
    <>
      <div className="caption">
        <span>{label}</span>
        {right}
      </div>
    </>
  );
};

export type CaptionButtonProps = {
  to: string;
  label?: string;
  onClick?: () => void;
};

export const CaptionButton = (props: CaptionButtonProps) => {
  const { to, label, onClick } = props;
  return (
    <>
      <NavLink to={to} className="captionButton" onClick={onClick}>
        {label}
      </NavLink>
    </>
  );
};
